<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        Terms & Conditions
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>Terms & Conditions</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <!-- ===============about section ============ -->
    <section>
        <!-- about  -->
        <div class="about cpy-8 ">
            <!-- container  -->
            <div class="container">
                <!-- row  -->
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-4">
                        <div class="about-content">
                            <div class="sec-head mb-3">
                                <h2 class="inside-head text-center mb-4">Terms & Conditions</h2>
                            </div>

                            <div class="about-content-inner mb-2">
                                <p class="mb-4 font-16 pb-2">This Privacy Policy governs the manner in which <span
                                        class="theme-color fw-semibold fst-italic">Prism Textile Machinery</span>
                                    collects, uses,
                                    maintains and discloses information collected from
                                    users (each, a "User") of the <a href="https://www.prismtextilemachinery.com/"
                                        class="theme-color fw-semibold fst-italic text-decoration-underline">https://www.prismtextilemachinery.com/</a>
                                    website ("Site"). This privacy
                                    policy applies to the Site and all products and services offered by <span
                                        class="theme-color fw-semibold fst-italic">Prism Textile Machinery</span>.
                                </p>

                                <h5 class="text-black fw-bold mb-3">Personal identification information</h5>
                                <p class="mb-4 font-16 pb-2">We may collect personal identification information
                                    from
                                    Users in a variety of ways, including, but not limited to, when Users visit our
                                    site, register on the site, place an order, subscribe to the newsletter, respond to
                                    a survey, fill out a form, and in connection with other activities, services,
                                    features or resources we make available on our Site. Users may be asked for, as
                                    appropriate, name, email address, mailing address, phone number, credit card
                                    information. Users may, however, visit our Site anonymously. We will collect
                                    personal identification information from Users only if they voluntarily submit such
                                    information to us. Users can always refuse to supply personally identification
                                    information, except that it may prevent them from engaging in certain Site related
                                    activities.</p>

                                <h5 class="text-black fw-bold mb-3">Non-personal identification information</h5>
                                <p class="mb-4 font-16 pb-2">We may collect non-personal identification information
                                    about Users whenever they interact with our Site. Non-personal identification
                                    information may include the browser name, the type of computer and technical
                                    information about Users means of connection to our Site, such as the operating
                                    system and the Internet service providers utilized and other similar information.
                                </p>

                                <h5 class="text-black fw-bold mb-3">Web browser cookies</h5>
                                <p class="mb-4 font-16 pb-2">Our Site may use "cookies" to enhance User experience.
                                    User's web browser places cookies on their hard drive for record-keeping purposes
                                    and sometimes to track information about them. User may choose to set their web
                                    browser to refuse cookies, or to alert you when cookies are being sent. If they do
                                    so, note that some parts of the Site may not function properly.
                                </p>

                                <h5 class="text-black fw-bold mb-3">How we use collected information</h5>
                                <p class="pb-0 mb-4 font-16"><span class="theme-color fw-semibold fst-italic">Prism
                                        Textile Machinery</span> collects and uses Users’
                                    personal information for the following purposes:</p>
                                <ul>
                                    <li class="privacy-li font-17 text-black">
                                        <strong>To improve customer service</strong>
                                        <p class="font-16 pb-0 mb-1">We use the information Users provide about
                                            themselves when placing an order only to provide service to that order. We
                                            do not share this information with outside parties except to the extent
                                            necessary to provide the service.</p>
                                    </li>
                                    <li class="privacy-li font-17 text-black">
                                        <strong>To personalize user experience</strong>
                                        <p class="font-16 pb-0 mb-1">We use information in the aggregate to understand
                                            how our Users as a group use the services and resources provided on our
                                            Site.</p>
                                    </li>
                                    <li class="privacy-li font-17 text-black">
                                        <strong>To improve our Site</strong>
                                        <p class="font-16 pb-0 mb-1">We use feedback you provide to improve our products
                                            and services.</p>
                                    </li>
                                    <li class="privacy-li font-17 text-black">
                                        <strong>To process payments</strong>
                                        <p class="font-16 pb-0 mb-1">We use the information Users provide about
                                            themselves when placing an order only to provide service to that order. We
                                            do not share this information with outside parties except to the extent
                                            necessary to provide the service.</p>
                                    </li>
                                    <li class="privacy-li font-17 text-black">
                                        <strong>To run a promotion, contest, survey or other Site feature</strong>
                                        <p class="font-16 pb-0 mb-1">To send Users information they agreed to receive
                                            about topics we think will be of interest to them.</p>
                                    </li>
                                    <li class="privacy-li font-17 text-black">
                                        <strong>To send periodic emails</strong>
                                        <p class="font-16 pb-0 mb-1">We may use the email address to send User
                                            information and updates pertaining to their order. It could also be used to
                                            respond to their inquiries, questions and/or other requests. If User decides
                                            to opt-in to our mailing list, they will receive emails that may include
                                            company news, updates, related product or service information, etc. If at
                                            any time the User would like to unsubscribe from receiving future emails, we
                                            include detailed unsubscribe instructions at the bottom of each email or the
                                            User may contact us via our Site.</p>
                                    </li>
                                </ul>

                                <h5 class="text-black fw-bold mb-3">How we protect your information</h5>
                                <p class="mb-4 font-16 pb-2">We adopt appropriate data collection, storage and
                                    processing practices and security measures to protect against unauthorized access,
                                    alteration, disclosure or destruction of your personal information, username,
                                    password, transaction information and data stored on our Site.
                                </p>

                                <h5 class="text-black fw-bold mb-3">Sharing your personal information</h5>
                                <p class="mb-4 font-16 pb-2">We do not sell, trade, or rent Users personal
                                    identification information to others. We may share generic aggregated demographic
                                    information not linked to any personal identification information regarding visitors
                                    and users with our business partners, trusted affiliates and advertisers for the
                                    purposes outlined above.We may use third party service providers to help us operate
                                    our business and the Site or administer activities on our behalf, such as sending
                                    out newsletters or surveys. We may share your information with these third parties
                                    for those limited purposes provided that you have given us your permission.
                                </p>

                                <h5 class="text-black fw-bold mb-3">Compliance with children's online privacy protection
                                    act</h5>
                                <p class="mb-4 font-16 pb-2">Protecting the privacy of the very young is especially
                                    important. For that reason, we never collect or maintain information at our Site
                                    from those we actually know are under 13, and no part of our website is structured
                                    to attract anyone under 13.
                                </p>

                                <h5 class="text-black fw-bold mb-3">Compliance with the California Consumer Privacy Act
                                    (CCPA)</h5>
                                <p class="mb-4 font-16 pb-2">This Privacy Statement for Users in California
                                    supplements the information contained in the Privacy Policy above. The following
                                    Statement is in compliance with the California Consumer Privacy Act (CCPA) and
                                    applies solely to Users who reside in the State of California.
                                </p>

                                <h5 class="text-black fw-bold mb-3">Collection of personal and non-personal
                                    identification information</h5>
                                <p class="mb-2 font-16 pb-0">We may collect the following categories of personal
                                    identification information from Users: name, email address, mailing address, IP
                                    address, telephone number, signature, account name, social security number, driver’s
                                    license or other state identification number, passport number and credit card
                                    information.</p>
                                <p class="mb-4 font-16 pb-2">We may also collect non-personal information about Users’
                                    internet activity, including: browser name, type of computer and technical
                                    information, operating system, internet provider, browsing history, search history
                                    and other information regarding a User’s interaction with a website or application.
                                </p>

                                <h5 class="text-black fw-bold mb-3">Third parties</h5>
                                <p class="mb-2 font-16 pb-0">We sometimes use third-party service providers to help us
                                    operate our business on our behalf, such as sending out newsletters or surveys. We
                                    may share your information with these third parties for those limited purposes
                                    provided that you have given us your permission. However, outside of that, we do not
                                    sell, share, rent, trade or disclose your personal information with any third-party
                                    companies.</p>
                                <p class="mb-4 font-16 pb-2">Users provide this information directly to our business or
                                    automatically through interaction with our Site. We collect personal identification
                                    information for the business and commercial purposes described in the “How we use
                                    collected information” section above.</p>

                                <h5 class="text-black fw-bold mb-3">Right to access your personal information</h5>
                                <p class="mb-2 font-16 pb-0">You have the right to access the personal information we
                                    hold about you. You also have the right to request a copy of the personal
                                    information we hold. If you want to access this data, send a description of the
                                    information you want us to share to <a href="mailto:sales@prismtextilemachinery.com"
                                        class="theme-color fw-semibold fst-italic text-decoration-underline">sales&#64;prismtextilemachinery.com</a>.
                                </p>
                                <p class="mb-4 font-16 pb-2">Personal information does not include “publicly available”
                                    information. Publicly available information is not covered by the CCPA.</p>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- row end  -->
            </div>
            <!-- container  -->
        </div>
        <!-- about end  -->
    </section>
    <!-- ============about section end ========= -->
</div>
<!-- body wrapper end -->